(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[33],{

/***/ "+EX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("Jwqi");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var GridColumn = function GridColumn(_ref) {
  var children = _ref.children,
      columnName = _ref.columnName,
      style = _ref.style,
      itemIndex = _ref.itemIndex;
  return __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default.a["col".concat(columnName)],
    style: style,
    "data-card-index": itemIndex
  }, children);
};

/* harmony default export */ __webpack_exports__["a"] = (GridColumn);

/***/ }),

/***/ "+LjS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("7WCW");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var GridRow = function GridRow(_ref) {
  var children = _ref.children,
      releatedProject = _ref.releatedProject,
      className = _ref.className;
  var ids = releatedProject ? 'releated-project-wrapper' : null;
  return __jsx("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a.row, className),
    id: ids
  }, children);
};

/* harmony default export */ __webpack_exports__["a"] = (GridRow);

/***/ }),

/***/ "3pPf":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"OX4Lw6"};

/***/ }),

/***/ "7WCW":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"_uCGq9"};

/***/ }),

/***/ "Dpqk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return faqData; });
var customProjectIds = {
  'nef-arsa': {
    mainCompanyId: '62f60f130766000128637384',
    projects: ['62f60a360766000128637382', // Nef city 82
    '62f60fa8d6f66100f489d6b2', // Nef arsa Ayvacık
    '62f617d39558b601759b1fd9', // Nef arsa Çanakkale
    '62f61299799e45021ca5477d', // Nef arsa Sakarya
    '62f66834385d990039de2664' // Nef arsa Lüleburgaz
    ]
  }
};
/* harmony default export */ __webpack_exports__["a"] = (customProjectIds);
var faqData = [{
  question: "Dubai'de Yatırım Neden Damac ile Yapılmalı?",
  answer: "DAMAC Gayrimenkul Geliştirme Limited'in yatırımcılara sağladığı avantajlar arasında güçlü finansal performans, tam geliştirme aşamasındaki iş modelinden kaynaklanan artan marjlar ve çekici getiriler bulunmaktadır. Ayrıca, uluslararası alanda tanınan bir marka olması, premium Dubai emlak pazarında lider konumda bulunması, sağlam iş modeli, iç tasarım, satış ve proje yürütme konularındaki uzmanlığı, hizmet ve konaklama yetenekleri, mevcut geliştirme hattı ve yeni fırsatları değerlendirme yeteneği gibi faktörler yatırımcılar için anlamlı bir değer önerisi oluşturmaktadır. Son olarak, deneyimli yönetim ekibi ve bağlı bir kurucu hissedarın varlığı, şirketin güvenilirliğini ve sürdürülebilir büyüme potansiyelini daha da güçlendirmektedir."
}, {
  question: "Yabancılar için Dubai'de Yatırım Yapmanın Avantajları Nelerdir?",
  answer: "Dubai'de yatırım yapmanın hem expats hem de non-resident yatırımcılara birçok avantajı vardır; bu avantajlar arasında vergi olmaması ve birçok iş fırsatının bulunması yer almaktadır. Emlak yatırımı yapmak isteyenler, emirlikte yıllık emlak vergisi, gelir vergisi veya sermaye kazancı vergisi olmamasından dolayı vergilerden muaf tutulurlar. Ayrıca, neredeyse her risk profiline uygun yatırım seçenekleri mevcuttur: hisse senedi ticaretinden emlak satın almaya, özel emeklilik düzenlemelerine ve daha fazlasına kadar. Dahası, Birleşik Arap Emirlikleri'nin FDI Yasası'ndaki son güncellemeler sayesinde, Dubai merkezli işlere yatırım yapmak için mükemmel bir zamanlamadır."
}, {
  question: "Dubai'de Yabancı Yatırımcılar için Kriterler Nelerdir?",
  answer: "Dubai'de bir yabancı yatırımcı olarak, 5 yıllık vizeye hak kazanmak için belirli kriterlere uymak gerekmektedir. Bu vize, en az 5 milyon AED değerinde bir gayrimenkule sahip yatırımcılar veya aynı değerde bir projeye sahip girişimciler için geçerlidir. Dubai'de iş kurmak veya mevcut bir projeye yatırım yapmak isteyen yabancı uyruklular da bu vizeden faydalanabilirler. Ayrıca, projenin önemli sermayeye ve somut varlıklara sahip olduğunu göstermek ve başarılı bir şekilde tamamlanmasını sağlamak için mali kaynaklara dair kanıtlar sunmak gerekmektedir."
}, {
  question: 'Yabancı Uyruklu ve Geçici Oturum Sağlayan Bireyler için Yatırım Seçenekleri Nelerdir?',
  answer: "Yabancı uyruklu ve geçici oturum sağlayan bireyler için Birleşik Arap Emirlikleri'nde bir dizi yatırım seçeneği vardır; bu seçenekler arasında hisse senedi fonları, değer & büyüme fonları, sabit getirili fonlar ve altın fonları bulunmaktadır. Yerel yatırım fonları yerel menkul kıymetlere, örneğin hisse senetleri ve tahvillere, yatırım yaparken; uluslararası fonlar, Birleşik Arap Emirlikleri dışındaki yatırımları çeşitlendirmek için idealdir. Ayrıca, yabancı yatırımcılar emlak satın alabilir, iş kurabilir ve borsada yer alabilir. Bu seçenekleri daha iyi anlamak ve bunlardan maksimum faydayı elde etmek için profesyonel tavsiyelere başvurmak önemlidir."
}, {
  question: 'Yabancı Yatırımcılar için Vergilendirme Süreci Nasıldır?',
  answer: "Dubai'deki yabancı yatırımcılara sermaye kazancı vergisi veya gelir vergisi uygulanmamaktadır. Ancak 2019'dan bu yana, yabancı uyrukluların tüm yerler için %5, konut villaları içinse kira değerleri üzerinden hesaplanan %7,5 ödemesi gerekmektedir. Ayrıca, yabancı bankalar, hükümetle özel düzenlemeler çerçevesinde yerel sermaye katılımı olmaksızın Dubai Emirliği'nde faaliyet göstermektedir."
}, {
  question: "Dubai'de Yabancıların Emlak Satın Alabileceği Alanlar Nelerdir?",
  answer: "Dubai'de yabancı mülkiyeti, serbest mülkiyet olarak belirlenmiş alanlarda mümkündür. Bu, vatandaş olmayanların ve expatların Dubai'de serbest mülkiyet alanındaki emlakları satın alabileceği anlamına gelir ki bunlar Dubai Emlak Departmanı (DLD) tarafından belirlenmiş serbest mülkiyet alanlarıdır. Bir yabancının Birleşik Arap Emirlikleri'nde konut mülkleri satın almak istiyorsa, bu mülklerin bu serbest mülkiyet veya kira mülkiyeti alanlarından birinde bulunması gerekmektedir. Ayrıca, herhangi bir yatırım yapmadan önce Dubai'deki yabancı yatırımları düzenleyen yönetmelikleri anlamak ve nitelikli profesyonellerden tavsiye almak önemlidir."
}, {
  question: 'DAMAC Properties Oturma Vizesi Almayı Nasıl Kolaylaştırır?',
  answer: "\n        <p>Dubai, k\xFCresel yat\u0131r\u0131mlar\u0131, turizmi ve sermayeyi \xE7ekmek amac\u0131yla Alt\u0131n \u0130kamet programlar\u0131n\u0131 tan\u0131tt\u0131. Bu programlar, belirli ko\u015Fullara dayanarak, expatlar\u0131n 5 veya 10 y\u0131l s\xFCreyle Birle\u015Fik Arap Emirlikleri'nde ikamet etmelerine olanak tan\u0131r. Ger\xE7ekle\u015Ftirmeleri m\xFCmk\xFCn kategoriler aras\u0131nda, gayrimenkul yat\u0131r\u0131mc\u0131lar\u0131, yarat\u0131c\u0131lar, yenilik\xE7iler, giri\u015Fimciler, insani giri\u015Fimciler ve t\u0131p uzmanlar\u0131 bulunmaktad\u0131r ve bunlar Birle\u015Fik Arap Emirlikleri'nde Alt\u0131n \u0130kamet i\xE7in ba\u015Fvuruda bulunabilir ve alabilirler.<p>\n        <p><b>DAMAC Properties, Alt\u0131n \u0130kamet i\xE7in ba\u015Fvuruda bulunma s\xFCreci i\xE7in \"DAMAC Living\" uygulamas\u0131 arac\u0131l\u0131\u011F\u0131yla basit bir yol sunar: </b></p>\n        <ul>\n          <li>DAMAC Living uygulamas\u0131n\u0131 indirin:</li>\n          <li>Uygulamada ki\u015Fisel verileri kaydedin.</li>\n          <li>Uygulama i\xE7indeki alt\u0131n ikamet ba\u015Fvuru hizmetine eri\u015Fim sa\u011Flay\u0131n.</li>\n        </ul>\n        <p>Bu ad\u0131mlar\u0131 tamamlad\u0131ktan sonra DAMAC Properties, m\xFC\u015Fteriye bir ba\u015Fvuru numaras\u0131 verir. Bu numara ile m\xFC\u015Fteri, do\u011Frudan ilgili ki\u015Filerle ileti\u015Fim kurabilir.</p>\n        <p>Alt\u0131n \u0130kamet, \xFClkeden istedi\u011Finiz zaman ayr\u0131lma esnekli\u011Fi, kefil gereksinimi olmamas\u0131, on y\u0131la kadar ge\xE7erlilik s\xFCresi ve belirli gereksinimlerin kar\u015F\u0131lanmas\u0131 durumunda ikametin yenilenme olana\u011F\u0131 gibi bir\xE7ok avantaj sunar.</p>\n        <span><b>Alt\u0131n \u0130kamet Vizesi S\xFCreci</b></span>\n        <p>Dubai'de 10 y\u0131ll\u0131k Alt\u0131n \u0130kamet i\xE7in \u015Fu ko\u015Fullar\u0131 kar\u015F\u0131lamak gerekiyor:</p>\n        <ul>\n          <li>En az 2 milyon AED de\u011Ferinde mevcut bir m\xFClk\xFCn sahibi olmak.</li>\n          <li>En az 2 milyon dirhem de\u011Ferinde olan, \xF6zellikle konut m\xFClkleri i\xE7in uygulanan 5 y\u0131ll\u0131k Alt\u0131n \u0130kamet i\xE7in, uygun bir \u015Fekilde Birle\u015Fik Arap Emirlikleri'ndeki \xF6nde gelen bir gayrimenkul geli\u015Ftirici taraf\u0131ndan in\u015Fa edilen bir m\xFClk\xFCn sahibi olmak.</li>\n          <li>E\u011Fer m\xFClk birden fazla ki\u015Fi taraf\u0131ndan sahipleniliyorsa, 5 y\u0131ll\u0131k Alt\u0131n ikamet al\u0131nabilmesi i\xE7in her bir ki\u015Finin toplamda 1 milyon dirheme sahip olmas\u0131.</li>\n          <li>10 y\u0131ll\u0131k Alt\u0131n \u0130kamet i\xE7in bir gayrimenkul yat\u0131r\u0131m fonuna 10 milyon dirhem yat\u0131r\u0131m yapmak.</li>\n        </ul>\n      "
}, {
  question: 'Dubai Gayrimenkulüne Yatırım Yapmak için İpuçları Nelerdir?',
  answer: "\n        <p>Dubai'de emlak yat\u0131r\u0131m\u0131 yaparken, farkl\u0131 m\xFClk t\xFCrlerini ve de\u011Ferlerini anlamak \xF6nemlidir. L\xFCks villalardan dairelere ve ticari gayrimenkullere kadar \xE7e\u015Fitli se\xE7enekler bulunmaktad\u0131r. Herhangi bir m\xFClke yat\u0131r\u0131m yapmadan \xF6nce piyasa durumunu ve riskleri ara\u015Ft\u0131rmak esast\u0131r. \u0130htiya\xE7lar\u0131n\u0131za ve b\xFCt\xE7enize en iyi uyacak m\xFClk t\xFCr\xFCn\xFC bilmek \xF6nemlidir. Ayr\u0131ca, piyasadaki dalgalanmalardan kaynaklanabilecek potansiyel riskleri de\u011Ferlendirmek \xF6nemlidir.</p>\n        <p>Dubai i\xE7in emlak yat\u0131r\u0131m\u0131 s\xF6z konusu oldu\u011Funda genellikle iki ana kategori bulunmaktad\u0131r: konut ve ticari emlak. Konut emlaklar\u0131, kiralama uygunlu\u011Fu ve sermaye de\u011Ferinin artma potansiyeli nedeniyle genellikle potansiyel al\u0131c\u0131lar i\xE7in \xE7ekicidir. \xD6te yandan, ticari emlaklar, ofis alan\u0131na veya perakende sat\u0131\u015F noktalar\u0131na ihtiya\xE7 duyan i\u015Fletmeleri hedefler. Her iki emlak t\xFCr\xFC de farkl\u0131 avantajlar sunar ve kendi risk setine sahiptir.</p>\n        <p>Konut emlaklar\u0131na yat\u0131r\u0131m yapmak, yat\u0131r\u0131mc\u0131lara \u015Fehirde h\u0131zl\u0131 bir yasal ikamet i\xE7in bir k\u0131sayol sa\u011Flayabilir. Yat\u0131r\u0131m dostu vize programlar\u0131 arac\u0131l\u0131\u011F\u0131yla konut sat\u0131n alanlar, ikamet vizelerine eri\u015Fim elde ederek \u015Fehirde \xFC\xE7 y\u0131la kadar kalma ve \xE7al\u0131\u015Fma imkan\u0131na sahip olabilirler. Bu, yat\u0131r\u0131mlar\u0131n\u0131 en iyi \u015Fekilde de\u011Ferlendirmek ve Dubai'de ya\u015Faman\u0131n avantajlar\u0131n\u0131n tad\u0131n\u0131 \xE7\u0131karmak isteyen yat\u0131r\u0131mc\u0131lar i\xE7in harika bir f\u0131rsatt\u0131r. Ancak, getirileri maksimize etmek i\xE7in dikkatlice ara\u015Ft\u0131rma yapmak ve do\u011Fru m\xFClk\xFC se\xE7mek \xF6nemlidir.</p>\n        <p>Yat\u0131r\u0131m\u0131n sa\u011Flam ve ba\u015Far\u0131l\u0131 olmas\u0131 i\xE7in uzman tavsiyesi almak \xF6nemlidir. Profesyonel emlak dan\u0131\u015Fmanlar\u0131, yat\u0131r\u0131mc\u0131lara potansiyel m\xFClkleri belirleme, yat\u0131r\u0131mla ili\u015Fkili riskleri de\u011Ferlendirme ve piyasa durumunu belirleme konusunda yard\u0131mc\u0131 olabilir.</p>\n        "
}];

/***/ }),

/***/ "Jwqi":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"col12":"M_QYkZ","col6":"_2ThrTq","col4":"_27N2Us","col7":"_3H6m54"};

/***/ }),

/***/ "PpEJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g4pe");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("URL7");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var ListingErrorBody = function ListingErrorBody(props) {
  var _props$errorType = props.errorType,
      errorType = _props$errorType === void 0 ? '' : _props$errorType,
      _props$message = props.message,
      message = _props$message === void 0 ? 'Üzgünüz, aradığınız sayfayı bulamadık. Aşağıdakilerden birini arıyor olabilir misiniz?' : _props$message;
  return __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a.errorBody
  }, __jsx(next_head__WEBPACK_IMPORTED_MODULE_1___default.a, null, __jsx("title", null, "404"), __jsx("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0"
  })), errorType && __jsx("h1", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a.errorType
  }, errorType), __jsx("p", null, message), __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a.columns
  }, __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a.column
  }, __jsx("ul", null, __jsx("li", null, "Sat\u0131l\u0131k"), __jsx("li", null, __jsx("a", {
    href: "/satilik-konut"
  }, "Konut")), __jsx("li", null, __jsx("a", {
    href: "/satilik-isyeri"
  }, "\u0130\u015Fyeri")), __jsx("li", null, __jsx("a", {
    href: "/devren-isyeri"
  }, "Devren \u0130\u015Fyeri")), __jsx("li", null, __jsx("a", {
    href: "/satilik-arsa"
  }, "Arsa")), __jsx("li", null, __jsx("a", {
    href: "/kat-karsiligi-arsa"
  }, "Kat Kar\u015F\u0131l\u0131\u011F\u0131 Arsa")), __jsx("li", null, __jsx("a", {
    href: "/satilik-turistik-tesis"
  }, "Turistik Tesis")))), __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a.column
  }, __jsx("ul", null, __jsx("li", null, "Kiral\u0131k"), __jsx("li", null, __jsx("a", {
    href: "/kiralik-konut"
  }, "Konut")), __jsx("li", null, __jsx("a", {
    href: "/gunluk-kiralik-konut"
  }, "G\xFCnl\xFCk Kiral\u0131k Konut")), __jsx("li", null, __jsx("a", {
    href: "/kiralik-isyeri"
  }, "\u0130\u015Fyeri")), __jsx("li", null, __jsx("a", {
    href: "/kiralik-arsa"
  }, "Arsa")), __jsx("li", null, __jsx("a", {
    href: "/kiralik-turistik-tesis"
  }, "Turistik Tesis")))), __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a.column
  }, __jsx("ul", null, __jsx("li", null, "Projeler"), __jsx("li", null, __jsx("a", {
    href: "/satilik-konut/projeler"
  }, "Konut")), __jsx("li", null, __jsx("a", {
    href: "/satilik-isyeri/projeler"
  }, "\u0130\u015Fyeri"))))));
};

/* harmony default export */ __webpack_exports__["a"] = (ListingErrorBody);

/***/ }),

/***/ "TReg":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"formNormal":"_2g3mLw","input":"_1vLphC","checkbox":"k6alLx","checkboxError":"_3TxEx6","reCaptcha":"_2Zie8E","button":"_3fMlNk","captchaError":"_1flfrD","errorText":"_1lo0WW","phoneError":"_2xM-WD","successWrapper":"_1c_2mm","icon":"CikRWO","formDark":"_3ULhHc","intlTelInput":"_185uoK","formControl":"_3vpge_"};

/***/ }),

/***/ "URL7":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"errorBody":"_2-tJz_","columns":"_2m6a_F","column":"_2RdpYX","errorType":"YnEPzZ"};

/***/ }),

/***/ "WbW0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("3pPf");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_1__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;



var GridContainer = function GridContainer(_ref) {
  var children = _ref.children;
  return __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_1___default.a.container
  }, children);
};

/* harmony default export */ __webpack_exports__["a"] = (GridContainer);

/***/ }),

/***/ "Xynn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getProjectDetail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getProjectDetailData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getCompanyInfo; });
/* unused harmony export overrideBaseUrlOfProjectData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return contact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return projectLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return companyLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sendProjectRadarSubscription; });
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HaE+");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("vDqi");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("g33+");






var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_3___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;
/**
 * Get project detail.
 */


function getProjectDetail(_ref) {
  var slug = _ref.slug;
  return _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/project/").concat(slug));
}
var getProjectDetailData = /*#__PURE__*/function () {
  var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(data) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/project/detail/").concat(data)).then(function (response) {
              return response.data;
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getProjectDetailData(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Get company info.
 */

function getCompanyInfo(_ref3) {
  var slug = _ref3.slug;
  return axios__WEBPACK_IMPORTED_MODULE_2___default.a.get("".concat(publicRuntimeConfig.apps.search.hostname, "/search/v1/project/company/").concat(slug));
}
/**
 * Override static urls inside raw html with dynamic paths based on staging environments
 * @param projectData
 * @returns {*}
 */

function overrideBaseUrlOfProjectData(projectData) {
  if (projectData && projectData.projects && projectData.projects.listing) {
    projectData.projects.listing.map(function (project) {
      if (project.url) {
        project.url = project.url.replace(/https:\/\/(.*)\.emlakjet\.com\/projeler\/proje/, "".concat(publicRuntimeConfig.app.hostname, "/projeler/proje"));
      }

      return project;
    });
  }

  return projectData;
}
function contact(params) {
  return _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].post("".concat(publicRuntimeConfig.apps.cms.hostname, "/api/v1/contact/"), params);
}
var projectLead = /*#__PURE__*/function () {
  var _ref4 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2(params) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].post("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/lead/projects"), params));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function projectLead(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * @params = { fullname, application, contracts, companyId, gRecaptchaResponse }
 */

var companyLead = /*#__PURE__*/function () {
  var _ref5 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee3(params) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _config_axiosInstance__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"].post("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/lead/company"), params));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function companyLead(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
var sendProjectRadarSubscription = /*#__PURE__*/function () {
  var _ref6 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee4(params) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", axios__WEBPACK_IMPORTED_MODULE_2___default.a.post("".concat(publicRuntimeConfig.apps.phoenixEmlakjetApi.hostname, "/e6t/v1/project-radar/subscription"), params));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function sendProjectRadarSubscription(_x4) {
    return _ref6.apply(this, arguments);
  };
}();

/***/ }),

/***/ "eiY6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("wx14");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("o0o1");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("HaE+");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__("mOvS");
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__("0iCA");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./services/project.js
var project = __webpack_require__("Xynn");

// EXTERNAL MODULE: ./services/kvkk.js
var kvkk = __webpack_require__("JON+");

// EXTERNAL MODULE: ./node_modules/@material-ui/core/TextField/index.js
var TextField = __webpack_require__("ZqOF");
var TextField_default = /*#__PURE__*/__webpack_require__.n(TextField);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/styles/index.js
var styles = __webpack_require__("SUMQ");

// CONCATENATED MODULE: ./src/components/e6t/desktop/project-input/index.jsx

var __jsx = react_default.a.createElement;




var project_input_styles = function styles(theme) {
  return {
    cssLabel: {
      transform: 'translate(14px, 16px)',
      fontSize: '14px',
      color: '#94a9af',
      '&$cssFocused': {
        color: '#94a9af',
        transform: 'translate(14px, 6px) scale(0.75)',
        transformOrigin: 'top left'
      }
    },
    cssFilled: {
      transform: 'translate(14px, 6px) scale(0.75) !important'
    },
    cssFocused: {},
    cssOutlinedInput: {
      '&$cssFocused $notchedOutline': {
        border: 'none'
      }
    },
    cssInput: {
      height: '35px',
      padding: '10px 15px 0 15px',
      margin: 0,
      color: '#000000',
      background: '#ffffff'
    },
    notchedOutline: {
      border: 'none'
    }
  };
};

var project_input_ProjectInput = function ProjectInput(props) {
  var classes = props.classes,
      label = props.label,
      onChange = props.onChange,
      error = props.error,
      valueType = props.valueType,
      placeholder = props.placeholder,
      shrink = props.shrink;
  var inputClasses = {
    root: classes.cssOutlinedInput,
    focused: classes.cssFocused,
    notchedOutline: classes.notchedOutline,
    input: classes.cssInput
  };
  var inputProps = {
    classes: inputClasses
  };
  var labelProps = {
    classes: {
      root: classes.cssLabel,
      focused: classes.cssFocused,
      shrink: classes.cssFilled
    }
  };
  return __jsx(TextField_default.a, Object(esm_extends["a" /* default */])({
    className: classes.margin,
    InputLabelProps: labelProps,
    InputProps: inputProps,
    label: label,
    variant: "outlined",
    id: "custom-css-outlined-input",
    onChange: onChange,
    error: error || false,
    placeholder: placeholder
  }, props));
};

/* harmony default export */ var project_input = (Object(styles["withStyles"])(project_input_styles)(project_input_ProjectInput));
// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/lib.js
var lib = __webpack_require__("z0pW");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/components/forms/ej-checkbox/index.jsx
var ej_checkbox = __webpack_require__("XUUv");

// EXTERNAL MODULE: ./src/components/desktop/elements/index.js + 12 modules
var desktop_elements = __webpack_require__("9aJQ");

// EXTERNAL MODULE: ./src/components/desktop/contracts/index.jsx + 1 modules
var desktop_contracts = __webpack_require__("8Xu1");

// EXTERNAL MODULE: ./src/utils/string-utils/index.js
var string_utils = __webpack_require__("KNqG");

// EXTERNAL MODULE: ./src/utils/validate/index.js
var validate = __webpack_require__("zHgr");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events.js
var events = __webpack_require__("tkT3");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/events/listing-detail.js
var listing_detail = __webpack_require__("UYDH");

// EXTERNAL MODULE: ./src/helpers/google-tag-manager/index.js
var google_tag_manager = __webpack_require__("kqSB");

// EXTERNAL MODULE: ./node_modules/react-phone-input-2/lib/style.css
var style = __webpack_require__("RuRJ");

// EXTERNAL MODULE: ./src/components/desktop/project-detail/form/styles.module.scss
var styles_module = __webpack_require__("TReg");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/project-detail/form/index.jsx





var _this = undefined;

var form_jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable radix */

/* eslint-disable no-underscore-dangle */


















 // import './phone.scss';

var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var form_ProjectDetailForm = function ProjectDetailForm(_ref, ref) {
  var _classnames;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'project' : _ref$type,
      testSelector = _ref.testSelector,
      data = _ref.data,
      usingWrapper = _ref.usingWrapper,
      isExtraFieldsVisible = _ref.isExtraFieldsVisible,
      onInputFocus = _ref.onInputFocus,
      onSuccess = _ref.onSuccess,
      resetForm = _ref.resetForm,
      location = _ref.location,
      customerRefId = _ref.customerRefId;
  var recaptchaRef = Object(react["useRef"])();

  var _useState = Object(react["useState"])(false),
      isHuman = _useState[0],
      setIsHuman = _useState[1];

  var _useState2 = Object(react["useState"])(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = Object(react["useState"])(null),
      selectedContract = _useState3[0],
      setSelectedContract = _useState3[1];

  var _useState4 = Object(react["useState"])([]),
      contracts = _useState4[0],
      setContracts = _useState4[1];

  var _useState5 = Object(react["useState"])(false),
      fetchingContracts = _useState5[0],
      setFetchingContracts = _useState5[1];

  var _useState6 = Object(react["useState"])(null),
      phoneInputData = _useState6[0],
      setPhoneInputData = _useState6[1];

  var _useState7 = Object(react["useState"])({
    name: '',
    phoneNumber: '',
    email: '',
    individualKvkk: {
      templateId: null,
      version: null,
      approved: false
    },
    formType: type === 'project' ? 'project_lead@projects' : 'company_lead@projects',
    application: 'desktop-web'
  }),
      formInputs = _useState7[0],
      setFormInputs = _useState7[1];

  var _useState8 = Object(react["useState"])({
    name: {
      value: false,
      message: null
    },
    phoneNumber: {
      value: false,
      message: null
    },
    email: {
      value: false,
      message: null
    },
    individualKvkk: {
      value: false,
      message: null
    }
  }),
      errors = _useState8[0],
      setErrors = _useState8[1];

  var isHeadFormSelector = testSelector === 'project-head-form';

  var handleInputFocus = function handleInputFocus() {
    if (onInputFocus) {
      onInputFocus();
    }
  };

  var handleInputOnChange = function handleInputOnChange(type, e) {
    var value = e.target.value;

    switch (type) {
      case 'name':
        if (Object(string_utils["b" /* checkOnlyLetters */])(e.target.value)) {
          setFormInputs(_objectSpread(_objectSpread({}, formInputs), {}, Object(defineProperty["default"])({}, type, value)));
        }

        break;

      default:
        setFormInputs(_objectSpread(_objectSpread({}, formInputs), {}, Object(defineProperty["default"])({}, type, value)));
    }

    setErrors(_objectSpread(_objectSpread({}, errors), {}, Object(defineProperty["default"])({}, type, {
      value: false,
      message: null
    })));
  };

  var handlePhoneInputChange = function handlePhoneInputChange(value, data) {
    setPhoneInputData(data);
    setFormInputs(_objectSpread(_objectSpread({}, formInputs), {}, {
      phoneNumber: value
    }));
  };

  var handleContractModalClose = function handleContractModalClose() {
    setSelectedContract(null);
  };

  var showContractDetail = function showContractDetail(e, key) {
    e.preventDefault();
    e.stopPropagation();
    var selected = contracts.find(function (c) {
      return c.name === key;
    });
    setSelectedContract(selected);
  };

  var handleContractModalCheckbox = function handleContractModalCheckbox(e, key) {
    e.preventDefault();
    setFormInputs(_objectSpread(_objectSpread({}, formInputs), {}, Object(defineProperty["default"])({}, key, _objectSpread(_objectSpread({}, formInputs[key]), {}, {
      approved: !formInputs[key].approved
    }))));
    setErrors(_objectSpread(_objectSpread({}, errors), {}, Object(defineProperty["default"])({}, key, {
      value: false,
      message: null
    })));
  };

  var handleCaptcha = function handleCaptcha() {
    setIsHuman(true);
  };

  var formValidate = /*#__PURE__*/function () {
    var _ref2 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      var fieldErrors, errorName, errorEmail, errorPhoneNumber, errorIndividualKvkk;
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(validate["a" /* default */])({
                name: formInputs.name === '' ? null : formInputs.name,
                phone: formInputs.phoneNumber === '' ? null : formInputs.phoneNumber,
                email: formInputs.email === '' ? null : formInputs.email
              });

            case 2:
              fieldErrors = _context.sent;
              errorName = lodash_default.a.get(fieldErrors, 'name', undefined);
              errorEmail = lodash_default.a.get(fieldErrors, 'email', undefined);
              errorPhoneNumber = true; // if (phoneInputData && phoneInputData.format.replace(/\s/g, '').length === formInputs.phoneNumber.length) {
              // We can validate phone numbers for selected coutry's phone number format
              // But the input does not allow us to write more than 15 digits
              // So, I commented out my quick solution above.
              // It's working like the old behavour.

              if (phoneInputData && formInputs.phoneNumber.length > 12) {
                errorPhoneNumber = false;
              }

              errorIndividualKvkk = !formInputs.individualKvkk.approved;

              if (!(errorName || errorEmail || errorIndividualKvkk || errorPhoneNumber)) {
                _context.next = 11;
                break;
              }

              setErrors(_objectSpread(_objectSpread({}, errors), {}, {
                name: {
                  value: errorName,
                  message: errorName
                },
                phoneNumber: {
                  value: errorPhoneNumber,
                  message: '*Geçerli bir telefon numarası girilmelidir'
                },
                email: {
                  value: errorEmail,
                  message: errorEmail
                },
                individualKvkk: {
                  value: errorIndividualKvkk,
                  message: errorIndividualKvkk
                }
              }));
              return _context.abrupt("return", false);

            case 11:
              return _context.abrupt("return", true);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function formValidate() {
      return _ref2.apply(this, arguments);
    };
  }();

  var sendProjectLead = function sendProjectLead() {
    var _data$company;

    var companyId = data === null || data === void 0 ? void 0 : (_data$company = data.company) === null || _data$company === void 0 ? void 0 : _data$company.id;
    var projectId = data === null || data === void 0 ? void 0 : data.id;
    Object(project["e" /* projectLead */])({
      fullname: formInputs.name,
      formType: formInputs.formType,
      email: formInputs.email,
      phone: formInputs.phoneNumber,
      application: formInputs.application,
      contracts: [formInputs.individualKvkk],
      companyId: companyId,
      projectId: projectId,
      memberId: parseInt(customerRefId)
    }).then(function (res) {
      if (!res.error) {
        var _data$name, _data$name$toLowerCas, _data$company2, _data$company2$name, _data$company2$name$t;

        onSuccess();
        Object(events["n" /* formGTMEvent */])({
          action: 'success',
          label: 'proje-detay-bilgi-al-success'
        });
        Object(google_tag_manager["a" /* GTMPushEvent */])({
          event: 'ga4_event',
          event_name: 'send_project_form',
          event_parameters: {
            project_name: data === null || data === void 0 ? void 0 : (_data$name = data.name) === null || _data$name === void 0 ? void 0 : (_data$name$toLowerCas = _data$name.toLowerCase()) === null || _data$name$toLowerCas === void 0 ? void 0 : _data$name$toLowerCas.replace(/\s/g, '-'),
            project_company_name: data === null || data === void 0 ? void 0 : (_data$company2 = data.company) === null || _data$company2 === void 0 ? void 0 : (_data$company2$name = _data$company2.name) === null || _data$company2$name === void 0 ? void 0 : (_data$company2$name$t = _data$company2$name.toLowerCase()) === null || _data$company2$name$t === void 0 ? void 0 : _data$company2$name$t.replace(/\s/g, '-'),
            form_type: location ? 'top' : 'bottom'
          }
        });
        Object(listing_detail["projectDetailFormSubmitGTMEvent"])(data);
      }
    });
  };

  var sendCompanyLead = /*#__PURE__*/function () {
    var _ref3 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
      var _recaptchaRef$current;

      var companyId;
      return regenerator_default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              companyId = data === null || data === void 0 ? void 0 : data.id;
              _context2.t0 = project["a" /* companyLead */];
              _context2.t1 = formInputs.name;
              _context2.t2 = formInputs.formType;
              _context2.t3 = formInputs.email;
              _context2.t4 = formInputs.phoneNumber;
              _context2.t5 = formInputs.application;
              _context2.t6 = [formInputs.individualKvkk];
              _context2.t7 = companyId;
              _context2.next = 11;
              return recaptchaRef === null || recaptchaRef === void 0 ? void 0 : (_recaptchaRef$current = recaptchaRef.current) === null || _recaptchaRef$current === void 0 ? void 0 : _recaptchaRef$current.executeAsync();

            case 11:
              _context2.t8 = _context2.sent;
              _context2.t9 = {
                fullname: _context2.t1,
                formType: _context2.t2,
                email: _context2.t3,
                phone: _context2.t4,
                application: _context2.t5,
                contracts: _context2.t6,
                companyId: _context2.t7,
                gRecaptchaResponse: _context2.t8
              };
              (0, _context2.t0)(_context2.t9).then(function (res) {
                if (!res.error) {
                  var _data$name2, _data$name2$toLowerCa;

                  onSuccess();
                  Object(events["n" /* formGTMEvent */])({
                    action: 'success',
                    label: 'proje-detay-bilgi-al-success'
                  });
                  Object(google_tag_manager["a" /* GTMPushEvent */])({
                    event: 'ga4_event',
                    event_name: 'send_project_form',
                    event_parameters: {
                      project_company_name: data === null || data === void 0 ? void 0 : (_data$name2 = data.name) === null || _data$name2 === void 0 ? void 0 : (_data$name2$toLowerCa = _data$name2.toLowerCase()) === null || _data$name2$toLowerCa === void 0 ? void 0 : _data$name2$toLowerCa.replace(/\s/g, '-'),
                      form_type: 'company'
                    }
                  });
                  Object(listing_detail["projectDetailFormSubmitGTMEvent"])(data);
                }
              });

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function sendCompanyLead() {
      return _ref3.apply(this, arguments);
    };
  }();

  var sendForm = function sendForm() {
    var entityId = '';
    var companyId = '';
    var city = '';
    var district = '';

    if (type === 'company') {
      var _data$city, _data$district;

      companyId = data === null || data === void 0 ? void 0 : data.id;
      city = data === null || data === void 0 ? void 0 : (_data$city = data.city) === null || _data$city === void 0 ? void 0 : _data$city.id;
      district = data === null || data === void 0 ? void 0 : (_data$district = data.district) === null || _data$district === void 0 ? void 0 : _data$district.id;
    } else {
      var _data$locationInfo, _data$locationInfo$ci, _data$locationInfo2, _data$locationInfo2$d;

      entityId = data === null || data === void 0 ? void 0 : data.id;
      companyId = data.company.id;
      city = data === null || data === void 0 ? void 0 : (_data$locationInfo = data.locationInfo) === null || _data$locationInfo === void 0 ? void 0 : (_data$locationInfo$ci = _data$locationInfo.city) === null || _data$locationInfo$ci === void 0 ? void 0 : _data$locationInfo$ci.id;
      district = data === null || data === void 0 ? void 0 : (_data$locationInfo2 = data.locationInfo) === null || _data$locationInfo2 === void 0 ? void 0 : (_data$locationInfo2$d = _data$locationInfo2.district) === null || _data$locationInfo2$d === void 0 ? void 0 : _data$locationInfo2$d.id;
    }

    Object(project["b" /* contact */])({
      allowAdv: false,
      allowShare: false,
      approval: true,
      name: formInputs.name,
      email: formInputs.email,
      phone_number: formInputs.phoneNumber,
      created_at: new Date().toISOString().slice(0, 19).replace('T', ' '),
      description: null,
      project: parseInt(entityId),
      company: parseInt(companyId),
      type: type,
      city: city,
      district: district,
      kvkkApproved: formInputs.individualKvkk.approved,
      member_id: parseInt(customerRefId)
    }).then(function () {
      recaptchaRef.current.reset();

      if (type === 'company') {
        sendCompanyLead();
      } else {
        sendProjectLead();
      }
    })["catch"](function () {
      setIsLoading(false);
      recaptchaRef.current.reset();
    });
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
      var isValid;
      return regenerator_default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setIsLoading(true);
              _context3.next = 3;
              return formValidate();

            case 3:
              isValid = _context3.sent;

              if (isValid) {
                _context3.next = 7;
                break;
              }

              setIsLoading(false);
              return _context3.abrupt("return");

            case 7:
              if (isHuman) {
                _context3.next = 10;
                break;
              }

              recaptchaRef.current.execute();
              return _context3.abrupt("return");

            case 10:
              Object(events["n" /* formGTMEvent */])({
                action: 'click',
                label: 'proje-detay-mesaj-gonder'
              });
              sendForm();

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmit() {
      return _ref4.apply(this, arguments);
    };
  }();

  var getContractContent = /*#__PURE__*/function () {
    var _ref5 = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
      var response, result, contractList;
      return regenerator_default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setFetchingContracts(true);
              _context4.prev = 1;
              _context4.next = 4;
              return Object(kvkk["b" /* getContract */])(formInputs.formType);

            case 4:
              response = _context4.sent;

              if (!(response.status === 200)) {
                _context4.next = 14;
                break;
              }

              result = response.data.result;
              contractList = {};

              if (!(result && result.length > 0)) {
                _context4.next = 11;
                break;
              }

              _context4.next = 11;
              return result.map(function (contract) {
                contractList[contract.name] = {
                  templateId: contract.templateId,
                  version: contract.version,
                  approved: false
                };
              });

            case 11:
              setFormInputs(_objectSpread(_objectSpread({}, formInputs), contractList));
              setContracts(result);
              setFetchingContracts(false);

            case 14:
              _context4.next = 19;
              break;

            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](1);
              setFetchingContracts(false);

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 16]]);
    }));

    return function getContractContent() {
      return _ref5.apply(this, arguments);
    };
  }();

  Object(react["useEffect"])(function () {
    getContractContent();
  }, []);
  Object(react["useEffect"])(function () {
    if (resetForm) {
      setFormInputs({
        name: '',
        phoneNumber: '',
        email: '',
        individualKvkk: {
          templateId: null,
          version: null,
          approved: false
        },
        formType: type === 'project' ? 'project_lead@projects' : 'company_lead@projects',
        application: 'desktop-web'
      });
      setErrors({
        name: {
          value: false,
          message: null
        },
        phoneNumber: {
          value: false,
          message: null
        },
        email: {
          value: false,
          message: null
        },
        individualKvkk: {
          value: false,
          message: null
        }
      });
    }
  }, [resetForm]);
  var checkboxClasses = classnames_default()((_classnames = {}, Object(defineProperty["default"])(_classnames, styles_module_default.a.checkbox, true), Object(defineProperty["default"])(_classnames, styles_module_default.a.checkboxError, errors.individualKvkk.value), _classnames));
  Object(react["useEffect"])(function () {
    if (isHuman) {
      handleSubmit();
    }
  }, [isHuman]);
  var ctaText = customerRefId ? 'Yatırımcı Yönlendir' : 'Bilgi Al';
  return form_jsx(react_default.a.Fragment, null, form_jsx(desktop_contracts["a" /* default */], {
    isLoading: fetchingContracts,
    isOpen: !!selectedContract,
    contract: selectedContract,
    onClose: handleContractModalClose
  }), form_jsx("div", {
    className: usingWrapper ? styles_module_default.a.formDark : styles_module_default.a.formNormal,
    ref: ref
  }, form_jsx("div", {
    className: styles_module_default.a.input
  }, form_jsx(project_input, Object(esm_extends["a" /* default */])({
    label: "Ad Soyad *",
    fullWidth: true,
    onChange: handleInputOnChange.bind(_this, 'name'),
    value: formInputs.name,
    error: errors.name.value,
    helperText: errors.name.message,
    onFocus: handleInputFocus
  }, isHeadFormSelector && {
    'data-test-selector': 'project-detail-head-form-name-input'
  }))), form_jsx("div", {
    className: styles_module_default.a.input
  }, form_jsx(lib_default.a, Object(esm_extends["a" /* default */])({
    country: "tr",
    placeholder: "Cep Telefonu *",
    autoFormat: false,
    enableLongNumbers: true,
    value: formInputs.phoneNumber,
    onChange: handlePhoneInputChange,
    onFocus: handleInputFocus
  }, isHeadFormSelector && {
    'data-test-selector': 'project-detail-head-form-phone-input'
  })), errors.phoneNumber.value && form_jsx("div", {
    className: styles_module_default.a.phoneError
  }, errors.phoneNumber.message)), form_jsx("div", {
    className: styles_module_default.a.input
  }, form_jsx(project_input, Object(esm_extends["a" /* default */])({
    label: "E-posta Adresi *",
    fullWidth: true,
    onChange: handleInputOnChange.bind(_this, 'email'),
    value: formInputs.email,
    error: errors.email.value,
    helperText: errors.email.message,
    onFocus: handleInputFocus
  }, isHeadFormSelector && {
    'data-test-selector': 'project-detail-head-form-mail-input'
  }))), (usingWrapper || isExtraFieldsVisible) && form_jsx(react_default.a.Fragment, null, form_jsx("div", {
    className: checkboxClasses,
    onClick: function onClick(e) {
      return handleContractModalCheckbox(e, 'individualKvkk');
    }
  }, form_jsx(ej_checkbox["a" /* default */], Object(esm_extends["a" /* default */])({
    label: form_jsx(react["Fragment"], null, "Ki\u015Fisel verilerin i\u015Flenmesiyle ilgili", ' ', form_jsx("u", {
      onClick: function onClick(e) {
        return showContractDetail(e, 'individualKvkk');
      }
    }, "Ayd\u0131nlatma Metni'ni"), " okuyup anlad\u0131\u011F\u0131m\u0131 beyan ve kabul ederim. *"),
    style: {
      width: '100%',
      display: 'flex',
      alignItems: 'flex-start'
    },
    checked: formInputs.individualKvkk.approved,
    error: errors.individualKvkk.value
  }, isHeadFormSelector && {
    'data-test-selector': 'project-detail-head-form-check-input'
  }))), form_jsx("div", {
    className: styles_module_default.a.reCaptcha
  }, form_jsx(esm["a" /* default */], Object(esm_extends["a" /* default */])({
    key: "captcha",
    sitekey: publicRuntimeConfig.keys.google.recaptcha,
    onChange: handleCaptcha.bind(_this),
    style: {
      transform: 'scale(0.8)',
      padding: '0 !important',
      transformOrigin: 'left top'
    },
    size: "invisible",
    badge: "inline",
    ref: recaptchaRef
  }, isHeadFormSelector && {
    'data-test-selector': 'project-detail-head-form-captcha'
  })))), form_jsx("div", {
    className: styles_module_default.a.button
  }, form_jsx(desktop_elements["b" /* Button */], Object(esm_extends["a" /* default */])({
    primary: true,
    disabled: isLoading,
    onClick: handleSubmit
  }, isHeadFormSelector && {
    'data-test-selector': 'project-detail-head-form-submit-btn'
  }), isLoading ? form_jsx(desktop_elements["f" /* Loader */], null) : form_jsx("span", null, ctaText)))));
};

/* harmony default export */ var project_detail_form = __webpack_exports__["a"] = (/*#__PURE__*/Object(react["forwardRef"])(form_ProjectDetailForm));

/***/ }),

/***/ "ezu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("9aJQ");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("TReg");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;




var ProjectDetailFormSuccess = function ProjectDetailFormSuccess() {
  return __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a.successWrapper
  }, __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a.icon
  }, __jsx(_elements__WEBPACK_IMPORTED_MODULE_1__[/* Icon */ "e"], {
    name: "check_circle",
    "data-test-selector": "project-detail-head-form-check"
  })), __jsx("p", {
    "data-test-selector": "project-detail-head-form-text"
  }, "Bilgilerinizi ald\u0131k,", __jsx("br", null), "en k\u0131sa zamanda size ula\u015Faca\u011F\u0131z."));
};

/* harmony default export */ __webpack_exports__["a"] = (ProjectDetailFormSuccess);

/***/ }),

/***/ "hl4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useIntersectionObserver; });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ODXe");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);


var useIntersectionObserver = function useIntersectionObserver(ref, options) {
  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_1__["useState"])(false),
      isIntersecting = _useState[0],
      setIntersecting = _useState[1];

  Object(react__WEBPACK_IMPORTED_MODULE_1__["useEffect"])(function () {
    var observer = new IntersectionObserver(function (_ref) {
      var _ref2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(_ref, 1),
          entry = _ref2[0];

      setIntersecting(entry.isIntersecting);
    }, options);
    if (ref.current) observer.observe(ref.current);
    return function () {
      observer.disconnect();
    };
  }, [ref, options]);
  return {
    isIntersecting: isIntersecting
  };
};

/***/ }),

/***/ "vGUj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSuffixByCurrency; });
var getSuffixByCurrency = function getSuffixByCurrency(currencySymbol) {
  var suffixes = {
    TL: "'den",
    $: "'dan",
    '€': "'dan",
    '£': "'dan"
  };
  return suffixes[currencySymbol] || "'dan";
};

/***/ })

}]);